import { useEffect } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { useAIProcessing } from '../../hooks/useAIProcessing';
import { useQRCodeUpload } from '../../hooks/useQRCodeUpload';
import { RootState } from '../../store/rootReducer';
import { createImageFile, createVideoFiles } from '../../utils/imageProcessing';
import { convertUrlToFile } from '../../utils/fileUtils';

const GlobalApiHandler = () => {
  const { photos, fourCutImage, videos, selectedPhotos, selectedFrameIndex, allowQrcode } =
    useSelector((state: RootState) => state.photo);
  const block = useSelector((state: RootState) => state.block.block, shallowEqual);
  const selectedThemeId = useSelector((state: RootState) => state.theme.selectedThemeId);

  const theme =
    selectedThemeId && block?.themes
      ? block.themes.find((t) => t.id === selectedThemeId) || block.themes[0]
      : block?.themes?.[0];

  const frame = theme?.frames[selectedFrameIndex];

  const { processCharacterize, processWithoutAI } = useAIProcessing();
  const { uploadMediaAndGenerateQR } = useQRCodeUpload(block?.blockCode || '');

  const handlePhoto = async (photoUrl: string, index: number): Promise<void> => {
    if (index < 0 || !theme) {
      console.warn('유효하지 않은 인덱스 또는 테마가 없음:', index);
      return;
    }

    try {
      const file = await convertUrlToFile(photoUrl);

      await processWithoutAI(file, index, 'skinImprovement');

      await processCharacterize(file, index, true, theme.aiModelCode, block?.id || 0);
    } catch (error) {
      console.error('이미지 처리 중 오류 발생:', error);
    }
  };

  const handleUploadMedia = async (): Promise<void> => {
    if (!frame || !theme || !block) {
      console.warn('프레임, 테마 또는 블록이 없음');
      return;
    }

    try {
      const imageFile = await createImageFile(fourCutImage, 'ai_composite.png');
      const selectedVideos = selectedPhotos.map((photo) => videos[photo.photoIndex]);
      const videoFiles = await createVideoFiles(selectedVideos);

      await uploadMediaAndGenerateQR(
        imageFile,
        videoFiles,
        frame.frameId,
        block.logo,
        JSON.stringify(block.style)
      );
    } catch (error) {
      console.error('미디어 업로드 준비 중 오류 발생:', error);
    }
  };

  useEffect(() => {
    const photo = photos.at(-1);
    if (photo) {
      handlePhoto(photo, photos.length - 1);
    }
  }, [photos, theme]);

  useEffect(() => {
    if (fourCutImage && allowQrcode) {
      handleUploadMedia();
    }
  }, [fourCutImage, allowQrcode]);

  return null;
};

export default GlobalApiHandler;
